import { render, staticRenderFns } from "./PdfComponent.html?vue&type=template&id=1c2be9a9&"
import script from "./PdfComponent.vue?vue&type=script&lang=ts&"
export * from "./PdfComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports